<template>
  <BittsModal
    v-model:visible="isVisible"
    title="SCIM Configuration"
    :width="650"
    variant="data"
    :show-secondary-button="false"
    primary-button-text="Done"
    @action="emit('closed')"
    @closed="$emit('closed')"
  >
    <div class="sso-config-modal__content">
      <div class="sso-config-modal__section">
        <BittsAlert
          message="Your SCIM token will be shown only once. Copy it and store it securely. You won't be able to view this token again."
          color="warning"
        />

        <!-- SCIM Base URL -->
        <BittsInput
          v-if="scimBaseUrl"
          :model-value="scimBaseUrl"
          :form-label="{
            title: 'SCIM Base URL',
            helpText: 'Use this URL when configuring your Identity Provider.',
          }"
          :read-only="true"
          :allow-copy="true"
          name="scim-base-url"
          data-testid="scim-base-url-input"
        >
          <template #prefix>
            <div class="flex items-center mr-8">
              <FontAwesomeIcon
                :icon="['fak', 'globe']"
                :style="{
                  height: '16px',
                  width: '16px',
                  color: 'currentColor',
                }"
                class="text-neutral-text-button"
              />
            </div>
          </template>
        </BittsInput>

        <!-- SCIM Bearer Token -->
        <BittsInput
          v-if="scimToken"
          :model-value="scimToken"
          :form-label="{
            title: 'SCIM Bearer Token',
            helpText: 'This token is shown only once. Store it securely.',
          }"
          :read-only="true"
          :allow-copy="true"
          name="scim-bearer-token"
          data-testid="scim-bearer-token-input"
        />
      </div>
    </div>
  </BittsModal>
</template>

<script setup lang="ts">
import { BittsAlert, BittsInput, BittsModal } from '@crossbeam/bitts';

import { ref, watch } from 'vue';

defineProps<{
  scimBaseUrl?: string | null;
  scimToken?: string | null;
}>();

const emit = defineEmits(['closed']);

const isVisible = ref(true);

watch(isVisible, (newVal) => {
  if (!newVal) {
    emit('closed');
  }
});
</script>

<style scoped lang="pcss">
@reference "../../../../css/theme.css";
.sso-config-modal__content {
  @apply flex flex-col gap-16 py-24;
}

.sso-config-modal__section {
  @apply flex flex-col gap-16;
}
</style>

<style lang="pcss">
@reference "../../../../css/theme.css";
.bitts-modal--data .o-bitts-modal__footer {
  justify-content: flex-end !important;
}
</style>
